import React from 'react';
import { Row } from 'react-bootstrap';
import './style.scss';

export default props => <Row className={`d-flex justify-content-center ${props.className}`}>
    <div className='zt-banner-getapp'>
        <div className='zt-banner-gradient'></div>
    </div>
</Row>